import './auth'
import './bootstrap'


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/index.js